import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendar } from "@fortawesome/free-regular-svg-icons"
import { faStar } from "@fortawesome/free-solid-svg-icons"
import { CircularProgressbar, buildStyles } from "react-circular-progressbar"
import { IKImage } from "imagekitio-react";
import CourseRating from "./CourseRating"
import { useNavigate } from "react-router-dom";
export default function LessonOverview({ playerDetails, mSkillProgress, skillData }) {
    const navigate  = useNavigate();
    return (
        <>
        <div className="w-full flex flex-col justify-between items-start p-3">
            <div className="w-full flex flex-row justify-between items-center border-b-2 pb-1 md:pb-4">
                <div className="w-full flex flex-col justify-center items-start">
                    <h2 className="font-bold text-xl md:text-2xl">About The Lesson</h2>
                    <h3 className="text-base md:text-lg pt-4">{playerDetails?.['lesson-name']}</h3>
                    <small>{playerDetails['lesson-description']}</small>
                </div>
                <div className=" w-16 h-16 md:hidden flex justify-centet items-center">
                    <CircularProgressbar value={mSkillProgress} text={`${mSkillProgress}%`} strokeWidth={9} styles={buildStyles({
                        textSize: '30px',
                        pathTransitionDuration: 0.5,
                        // Colors
                        pathColor: `#68DF5B`,
                        textColor: '#000',
                        trailColor: '#fff',
                    })} />

                </div>
            </div>
            <div className="w-full flex flex-col pt-3">
                <h2 className="font-bold text-xl md:text-2xl">About The Course</h2>
                <div className="w-full md:flex-row flex-col flex justify-between items-start mt-4 pt-4 border-2 border-slate-200 rounded-lg p-3 px-4">
                    <p className="md:p-0 pb-4 font-semibold">Description</p>
                    <p className="md:w-2/3 md:mr-8 m-0 w-full md:text-base text-xs">{skillData?.['skill-description']}</p>
                </div>
                <div className="w-full flex flex-col justify-between items-center border-2 border-slate-200 rounded-lg p-3 px-4 mt-4">
                    <div className="w-full flex justify-between items-start pt-4">
                        <p>Overall Rating</p>
                        <p className="md:w-2/3 md:mr-8 m-0">
                            <FontAwesomeIcon icon={faStar} size="lg" className="text-yellow-500" />
                            <FontAwesomeIcon icon={faStar} size="lg" className="text-yellow-500" />
                            <FontAwesomeIcon icon={faStar} size="lg" className="text-yellow-500" />
                            <FontAwesomeIcon icon={faStar} size="lg" className="text-yellow-500" />
                            <FontAwesomeIcon icon={faStar} size="lg" className="text-yellow-500" />
                        </p>
                    </div>
                    <div className="w-full flex justify-between items-start pt-4">
                        <p>Enrolled Users</p>
                        <p className="md:w-2/3 md:mr-8 m-0">{skillData?.enrolled_user_prefix?.toString() + skillData?.registered_students}</p>
                    </div>
                    <div className="w-full flex justify-between items-start pt-4">
                        <p>Last Updated</p>
                        <div className="flex justify-start items-center md:w-2/3 md:mr-8 m-0 md:text-base text-xs">
                            <FontAwesomeIcon icon={faCalendar} />
                            <p className="md:mx-3 ml-3">{(new Date(skillData?.created_at)).toLocaleString().slice(0, 8)}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-full">
                <CourseRating />
            </div>
        </div>

        
            <div className="w-11/12 h-52  md:w-5/12 md:h-48 flex flex-col justify-center  items-center bg-overview_green rounded-lg md:ml-10 ">
                <div className="md: mt-2">
                    <img
                        urlEndpoint="https://assets.learntube.ai/files/"
                        src={"https://assets.learntube.ai/files/Content_player/newimage.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658385772244"}
                        transformation={[{
                            "height": "160",
                            "width": "160",
                        }]}       
                    />       
                </div>
                    <h1 className="text-white text-xl mt-3 mb-2 md:mt-1 md:mb-0">Gift free course to a friend.</h1>
                    <button class="bg-white shadow-xl font-bold text-green-700 w-36 h-10 rounded-md hover:bg-gray-300 mb-2" onClick={(event)=>  navigate('/my-profile/user/referrals')}>Invite friends</button>
            </div> 
            

        </>
    )
}